module.exports = __webpack_public_path__ + "/images/logo-af-sephora.7558c43.svg";